import {PerPageOptions} from "@/helpers/constants";

export default class AsiListTableOptions {

	public sortBy: string[];
	public sortDesc: boolean[];
	public page: number;
	public itemsPerPage: number;

	constructor(sortBy: string[] = [], sortDesc: boolean[] = [], page: number = 1, itemsPerPage: number = PerPageOptions[0]) {
		this.sortBy = sortBy;
		this.sortDesc = sortDesc;
		this.page = page;
		this.itemsPerPage = itemsPerPage;
	}

}
